import { render, staticRenderFns } from "./NominacionExport.vue?vue&type=template&id=2e2e1366"
import script from "./NominacionExport.vue?vue&type=script&lang=js"
export * from "./NominacionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports